import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { StoreProvider } from './StoreContext';
import SyncBanner from './SyncBanner';
import Products from './Products';
import './AmazonPricingHub.css';

// One tool, two screens, under the Hub's shell (settings are on /settings). The store selector and the
// sync banner belong to the tool, not the shell, so they live here.
export default function AmazonPricingHub() {
  return (
    <StoreProvider>
      <div className="uh uh-page aph">
        <SyncBanner />
        <Routes>
          <Route path="/" element={<Products />} />
          <Route path="/products/:asin" element={<Products />} />
          {/* The tool's settings live on the Hub's Settings page now. */}
          <Route path="/settings" element={<Navigate to="/settings/pricing-hub" replace />} />
          <Route path="*" element={<Navigate to="/amazon-pricing-hub" replace />} />
        </Routes>
      </div>
    </StoreProvider>
  );
}
